import React, { useState, useEffect } from "react";
import { axiosReq } from "../../commons/axiosReq";
import User from "../../assets/icon/NewsIcons/MainAdmin/NewsPerson";
import Search from "../../assets/icon/NewsIcons/MainAdmin/NewsSearch";
import MainAdminJobsTable from "../../components/MainAdmin/Table/MainAdminJobsTable";
import DetailJobModal from "../../components/MainAdmin/Modals/DetailJobModal";
import DeleteModalWriters from "../../components/MainAdmin/Modals/DeleteModalWriters";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";

const colourStyles = {
    control: (base) => ({ ...base, backgroundColor: "white", minHeight: 35, height: 35 }),
    valueContainer: (base) => ({ ...base, height: 35, padding: "0 8px" }),
    option: (base) => ({ ...base, backgroundColor: "white", color: "#000" }),
};

const MainAdminJobs = () => {
    const titleRow = ["عنوان", "شرکت", "موقعیت", "کشور", "کاربر", "مهلت"];
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [reCheck, setRecheck] = useState(false);
    const [allJobs, setAllJobs] = useState([]);
    const [countries, setCountries] = useState([]);
    const [data, setData] = useState(null);
    const [search, setSearch] = useState("");
    const [filterCountry, setFilterCountry] = useState(null);
    const [filterUser, setFilterUser] = useState("");
    const [page, setPage] = useState(1);
    const [row, setRow] = useState(10);
    let navigate = useNavigate();

    const GetData = async () => {
        const res = await axiosReq("Job/Admin", "get");
        const list = Array.isArray(res) ? res : res?.data || [];
        setAllJobs(list);
    };

    const GetCountries = async () => {
        const res = await axiosReq("University/GetCountries", "get");
        const list = Array.isArray(res) ? res : res?.data || [];
        setCountries(list.map((c) => ({ value: c.countryId, label: c.name })));
    };

    const auth = async () => {
        const cookies = new Cookies();
        var token = cookies.get("token");
        if (!token) {
            navigate("/");
        } else {
            GetData();
            GetCountries();
        }
    };

    useEffect(() => {
        auth();
    }, [reCheck]);

    const filteredJobs = allJobs.filter((j) => {
        if (search) {
            const s = search.toLowerCase();
            if (
                !(j.title || "").toLowerCase().includes(s) &&
                !(j.company || "").toLowerCase().includes(s) &&
                !(j.location || "").toLowerCase().includes(s) &&
                !(j.tagsCsv || "").toLowerCase().includes(s)
            ) {
                return false;
            }
        }
        if (filterCountry && j.countryId !== filterCountry.value) {
            return false;
        }
        if (filterUser) {
            const u = filterUser.toLowerCase();
            const userName = `${j.userName || ""} ${j.userFamily || ""} ${j.userEmail || ""}`.toLowerCase();
            if (!userName.includes(u)) {
                return false;
            }
        }
        return true;
    });

    const count = filteredJobs.length;
    const pagedJobs = filteredJobs.slice((page - 1) * row, page * row);

    useEffect(() => {
        setPage(1);
    }, [search, filterCountry, filterUser, row]);

    return (
        <div>
            <div className="p-[20px] flex flex-wrap justify-between items-center border-b-2 border-borderGray">
                <div className="flex justify-start items-center">
                    <div><User color={"black"} /></div>
                    <p className="font-IRANYekanExtra text-[15px] mr-[15px]">مدیریت شغل‌ها</p>
                </div>
                <div className="flex flex-wrap justify-start items-center">
                    <div className="w-[238px] h-[40px] rounded-[10px] shadow-search-shadow p-[10px] flex justify-between items-center mb-5">
                        <input
                            onChange={(e) => setSearch(e.target.value)}
                            className="font-IRANYekanNormal focus:outline-none placeholder-lightGray"
                            type="text"
                            placeholder="جستجوی عنوان، شرکت ..."
                        />
                        <button><Search /></button>
                    </div>
                </div>
            </div>

            <div className="px-[20px] pt-[10px] pb-[5px] flex flex-wrap gap-3 items-center">
                <div className="w-[180px]">
                    <Select
                        options={countries}
                        value={filterCountry}
                        onChange={setFilterCountry}
                        placeholder="فیلتر کشور"
                        isSearchable={true}
                        isClearable={true}
                        styles={colourStyles}
                    />
                </div>
                <div className="w-[180px] h-[35px] rounded-[10px] shadow-search-shadow flex items-center px-[10px]">
                    <input
                        onChange={(e) => setFilterUser(e.target.value)}
                        className="font-IRANYekanNormal text-[13px] focus:outline-none placeholder-lightGray w-full"
                        type="text"
                        placeholder="فیلتر کاربر ..."
                    />
                </div>
            </div>

            <div className="pt-[10px] px-[20px] pb-[280px]">
                <MainAdminJobsTable
                    detail={true}
                    deleted={true}
                    setShowDetailModal={setShowDetailModal}
                    setShowDeleteModal={setShowDeleteModal}
                    setData={setData}
                    titleRow={titleRow}
                    writersList={pagedJobs}
                    count={count}
                    page={page}
                    setPage={setPage}
                    row={row}
                    setRow={setRow}
                />
            </div>

            {showDetailModal && data ? (
                <DetailJobModal setShowModal={setShowDetailModal} data={data} />
            ) : null}

            {showDeleteModal ? (
                <DeleteModalWriters
                    title={"حذف شغل"}
                    buttonName={"حذف"}
                    text={"آیا از حذف شغل انتخاب شده اطمینان دارید ؟"}
                    setShowModal={setShowDeleteModal}
                    api={"Job/Admin/" + data?.jobId}
                    reCheck={reCheck}
                    setRecheck={setRecheck}
                />
            ) : null}
        </div>
    );
};

export default MainAdminJobs;